import {
  Agent,
  formatAgentName,
  PointOfSales,
} from '~domains/partner-application/entities/application';
import { Card } from '~domains/partner-application/shared/ui/card';

import { convertISOToPhDate } from '~shared/lib/convert-date';

import { Button } from '@breezeventures/ui-kit/button';
import { Typography } from '@breezeventures/ui-kit/typography';

import { ReviewItem } from './review-item';

type AgentsReviewProps = {
  agents: Agent[] | undefined;
  pointsOfSales: PointOfSales[] | undefined;
  onEdit?: () => void;
};

export const AgentsReview = ({
  agents,
  pointsOfSales,
  onEdit,
}: AgentsReviewProps) => {
  if (!agents?.length || !pointsOfSales?.length) {
    return null;
  }

  const pointOfSalesNamesMap = pointsOfSales.reduce(
    (acc, pos) => {
      acc[pos.uiId] = pos.name;
      return acc;
    },
    {} as Record<string, string>
  );

  return (
    <div className="flex flex-col gap-3 pt-3">
      <div className="flex items-center justify-between gap-2">
        <Typography.Title size="2xs" tag="div">
          Agents
        </Typography.Title>
        {onEdit && (
          <Button
            onClick={onEdit}
            type="button"
            size="s"
            variant="secondary"
            aria-label="Edit Agents"
          >
            Edit
          </Button>
        )}
      </div>

      <div className="flex flex-col gap-3">
        {agents.map((agent) => {
          const stores = agent.assignedPointsOfSales
            .map((storeId) => pointOfSalesNamesMap[storeId])
            .join(', ');

          return (
            <Card
              key={agent.uiId}
              header={formatAgentName(agent)}
              subheader={stores}
              expandable
            >
              <div className="grid grid-cols-2 gap-4">
                <ReviewItem title="First name" value={agent.firstName} />
                <ReviewItem title="Middle name" value={agent.middleName} />
                <ReviewItem title="Last name" value={agent.lastName} />
                <ReviewItem
                  title="Birth date"
                  value={convertISOToPhDate(agent.birthDate)}
                />
                <ReviewItem title="Mobile phone" value={agent.mobilePhone} />
                <ReviewItem
                  title="Stores"
                  value={stores}
                  className="col-span-full"
                />
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
